import { CSSTransitionGroup } from "react-transition-group";
import styled from "styled-components";

const enter = "fade-in-enter";
const enterActive = "fade-in-enter-active";
const leave = "fade-in-leave";
const leaveActive = "fade-in-leave-active";
const timeout = 200;

const FadeInLeft = styled(CSSTransitionGroup).attrs({
  transitionName: { enter, enterActive, leave, leaveActive },
  transitionEnterTimeout: timeout,
  transitionLeaveTimeout: timeout
})`
  .${enter} {
    opacity: 0;
    transform: translateX(-100%);
  }
  .${enterActive} {
    opacity: 1;
    transform: translateX(0);
    transition: all ${timeout}ms ease-out;
  }
  .${leave} {
    opacity: 1;
    transform: translateX(0);
  }
  .${leaveActive} {
    opacity: 0;
    transform: translateX(-100%);
    transition: all ${timeout}ms ease-in;
  }
`;

export default FadeInLeft;



// WEBPACK FOOTER //
// ./src/animations/FadeInLeft.js